import Moment from "react-moment";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

export function ReportHeader({isSmallScreen, heading,subheading,description}) {
  return (
    <section className={isSmallScreen ? "modules my-4" : "modules my-5"}>
      <div
        className={
          isSmallScreen ? "container-fluid dashboard_container" : "container"
        }
      >
        <div className="box">
          <div
            className="upperBox"
            style={{ display: isSmallScreen ? "none" : "" }}
          >
            <div className="alignItem">
              <div className="row">
                <div className="boxRow">
                  <div className="boxRowLeft">
                    <div className="pathDetail">
                      <h1 className="className">{heading}</h1>
                      <h2 style={{ fontWeight: "700" }}>{subheading}</h2>
                      <p style={{ fontWeight: "600" }}>{description}</p>
                    </div>
                  </div>
                  <div className="DateBox" style={{ marginLeft: "auto" }}>
                    <h5 className="ms-auto" style={{ fontWeight: "600" }}>
                      <CalendarTodayIcon />{" "}
                      {<Moment format="DD MMMM, YYYY">{new Date()}</Moment>}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
